import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';

// identifier
export const ASYNC_EXCEL_EXPORT_SLICE = 'asyncExcelExport';

interface AsyncExcelExportState {
  exportProgress: number;
  showProgressBar: boolean;
}

// default state
const initialState: AsyncExcelExportState = {
  exportProgress: 0,
  showProgressBar: false,
};

//slice
const exportPptModalSlice = createSlice({
  name: ASYNC_EXCEL_EXPORT_SLICE,
  initialState,
  reducers: {
    setAsyncExcelExportProgress: (state: AsyncExcelExportState, action: PayloadAction<number>) => {
      state.exportProgress = action.payload;
    },
    setShowAsyncExcelExportProgressBar: (
      state: AsyncExcelExportState,
      action: PayloadAction<boolean>
    ) => {
      state.showProgressBar = action.payload;
    },
  },
});

//selectors

export const selectAsyncExcelExportProgress = (state: RootState) =>
  state.asyncExcelExport.exportProgress;
export const selectShowAsyncExcelExportProgressBar = (state: RootState) =>
  state.asyncExcelExport.showProgressBar;

//actions
export const { setAsyncExcelExportProgress, setShowAsyncExcelExportProgressBar } =
  exportPptModalSlice.actions;

//reducer
export default exportPptModalSlice;
